export const PARENT_CHANNELS = 6
export const AUTOCOMPLETE_DROPDOWN_TITLE = 'autocomplete_dropdown_title'
export const TYPE_CHANNEL = 'channel'
export const TYPE_FACEBOOK = 'facebook'
export const TYPE_TITLE = 'title'
export const TYPE_INSTAGRAM = 'instagram'
export const TYPE_TWITTER = 'twitter'
export const TYPE_LINKEDIN = 'linkedin'

export const CHANNEL_AUTOMATED_CALL = 9

export const CONTACT_TYPE_APP = 0
export const CONTACT_TYPE_REGISTERED = 1
export const CONTACT_TYPE_CRM = 2
export const CONTACT_TYPE_OTHET = 3
